import type { RemoteAudioTrack } from "twilio-video";
import { useTrackAttachment } from "../hooks/useTrackAttachment";

export interface RemoteAudioTrackPlayerProps {
  /** The remote audio track to play. */
  track: RemoteAudioTrack;
}

/**
 * Plays a single remote audio track through its own <audio> element.
 *
 * Rendering one player per track lets a participant's microphone and screen-share
 * audio play at the same time instead of overwriting one another.
 */
export const RemoteAudioTrackPlayer = ({ track }: RemoteAudioTrackPlayerProps) => {
  const audioRef = useTrackAttachment<HTMLAudioElement>(track);

  return <audio ref={audioRef} autoPlay />;
};
